import { render, staticRenderFns } from "./ParticipationData.vue?vue&type=template&id=23b00152"
import script from "./ParticipationData.vue?vue&type=script&lang=js"
export * from "./ParticipationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports